/** Zahlen, Zeiten und Preise auf Deutsch. */

export function formatClock(totalSeconds: number): string {
  const s = Math.max(0, Math.floor(totalSeconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const mm = h > 0 ? String(m).padStart(2, '0') : String(m);
  return h > 0 ? `${h}:${mm}:${String(sec).padStart(2, '0')}` : `${mm}:${String(sec).padStart(2, '0')}`;
}

/** „4:52“ Stunden oder „21 Min.“ – für die Kennzahlen im Kopf. */
export function formatDurationBig(totalSeconds: number): { value: string; label: string } {
  const minutes = Math.round(totalSeconds / 60);
  if (minutes >= 60) return { value: `${Math.floor(minutes / 60)}:${String(minutes % 60).padStart(2, '0')}`, label: 'Stunden' };
  return { value: String(Math.max(1, minutes)), label: 'Minuten' };
}

export function formatPrice(cents: number, currency = 'EUR'): string {
  if (cents === 0) return 'Kostenlos';
  return new Intl.NumberFormat('de-DE', { style: 'currency', currency, minimumFractionDigits: cents % 100 === 0 ? 0 : 2 }).format(cents / 100);
}

export function formatDate(iso: string): string {
  return new Intl.DateTimeFormat('de-DE', { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(iso));
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024 ** 2) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
  return `${(bytes / 1024 ** 2).toFixed(bytes < 10 * 1024 ** 2 ? 1 : 0).replace('.', ',')} MB`;
}

export function pad2(n: number): string {
  return String(n).padStart(2, '0');
}

/** Mehrzahl ohne Grammatikfehler: plural(3, 'Lektion', 'Lektionen') → „3 Lektionen“. */
export function plural(n: number, one: string, many: string): string {
  return `${n} ${n === 1 ? one : many}`;
}
